/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CircleMinus = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 24">
      <path d="M6.5 12H17.5" stroke="#2F3037" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#2F3037" fill="none" />
    </BaseSvgIcon>
  )
}

export default CircleMinus
